import type { MutationSettings } from '@customTypes/index';
import { useMutation } from '@tanstack/react-query';

import type { CreateConversationsParams } from './request';
import { createConversation } from './request';

export const useCreateConversationMutation = (
  settings?: MutationSettings<
    CreateConversationsParams,
    typeof createConversation
  >
) =>
  useMutation({
    mutationKey: ['createConversation'],
    mutationFn: ({ params, config }) => createConversation({ params, config }),
    ...settings?.options
  });
